import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddBranch() {
  const history = useHistory();
  const [company_data, setCompany_data] = useState([]);
  const [company_id, setCompanyId] = useState(null);
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  //fetch Company Data
  const getCompanyData = async () => {
    try {
      const data = await api.get("api/master/company");
        
      setCompany_data(data?.data?.data);
    } catch (e) {
      console.log(e);
    }
  };

  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getCompanyData();
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          สาขา
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Branch
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Create Branch
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            company_id: "",
            branch_no: "",
            branch_name: "",
            address: "",
            telephone: "",
            fax: "",
            remark: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.branch_no || values.branch_no === "") {
              errors.branch_no = "Required";
            }
            if (!values.branch_name || values.branch_name === "") {
              errors.branch_name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                companyId: company_id,
                no: values.branch_no,
                name: values.branch_name,
                address: values.address,
                phone: values.telephone,
                fax: values.fax,
                remark: values.remark,
                status: 1,
                createId: EmpId,
              };

              api
                .post("api/branch/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มสาขาสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Branch");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <div style={{ display: "flex" }}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={company_data}
                      style={{ width: "50%", marginRight: 5 }}
                      getOptionLabel={(option) => option.CompanyName}
                      classes={{ root: !company_id ? classes.customOutline : null }}
                      onChange={(x, y) => {
                        if (y !== null) {
                          setCompanyId(y.CompanyId);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          name="company_id"
                          label="Company"
                          variant="outlined"
                          required
                          placeholder="Company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          InputLabelProps={{ shrink: true }}
                          value={values.company_id}
                          {...params}
                          fullWidth
                        />
                      )}
                    />

                    <TextField
                      name="branch_no"
                      label="Branch No"
                      variant="outlined"
                      placeholder="Branch No"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.branch_no}
                      classes={{ root: !values.branch_no ? classes.customOutline : null }}
                    />
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="branch_name"
                      label="Branch Name"
                      variant="outlined"
                      required
                      placeholder="Branch Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.branch_name}
                      classes={{ root: !values.branch_name ? classes.customOutline : null }}
                    />

                    <TextField
                      name="telephone"
                      label="Telephone"
                      variant="outlined"
                      placeholder="Telephone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.telephone}
                    />
                    {errors.telephone && touched.telephone && errors.telephone}
                    <TextField
                      name="fax"
                      label="Fax"
                      variant="outlined"
                      placeholder="Fax"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.fax}
                    />
                    {errors.fax && touched.fax && errors.fax}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <TextField
                      name="address"
                      label="Address"
                      variant="outlined"
                      placeholder="Address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.address}
                      fullWidth
                    />
                    {errors.address && touched.address && errors.address}
                  </div>

                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <TextField
                      fullWidth
                      rows={3}
                      multiline={true}
                      label="Remark"
                      placeholder="Remark"
                      InputLabelProps={{ shrink: true }}
                      name="remark"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.remark}
                    />
                    {errors.remark && touched.remark && errors.remark}
                  </div>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
